<span class="st-rundown-properties-full-screen__label">{{ popUpTitle() }}</span>
<div class="st-rundown-properties-full-screen-content">
    <st-rundown-properties
        [record]="localRecord()"
        [options]="propertiesOptions()"
        (propertyChanged)="propertyChanged($event)"
        (recordChanged)="onRecordChanged($event)" />
    <div class="st-rundown-properties-full-screen-content__footer">
        <div class="st-rundown-properties-full-screen-content__footer-buttons">
            <button
                mat-button
                (click)="closeModal()">
                {{ languageSettings.PSTWebCancelButtonLabel }}
            </button>
            <button
                class="st-rundown-properties-full-screen-content__footer-buttons__create"
                mat-button
                [disabled]="disableCreate() || rundownArchived()"
                (click)="create()">
                @if (!loading()) {
                    {{ languageSettings.PSTWebSaveButtonLabel }}
                } @else {
                    <st-loader
                        class="st-topic-full-screen-create-footer-buttons--spinner"
                        [diameter]="30"
                        [strokeWidth]="5" />
                }
            </button>
        </div>
    </div>
</div>
